import React, { useState, useEffect, useCallback } from "react";
import "./organization-access-list-upload.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";

import {
  clearNotifications,
  selectAccessListNotifications,
  getOrganizationAccessList,
  selectCurrentList,
  setSelectedList,
  selectValidatedMember,
  validateOrganizationAccessList,
  importOrganizationAccessList,
  setValidatedMember
} from "../../reducers/accessSlice";

import {
  uploadFile,
  setUploadedFile,
  selectUploadedFile,
  clearUtilityNotifications,
} from "../../reducers/utilitySlice";
import { createFormFromFile } from "../../helpers/Utilities";

import { accessListUploadForm } from "../../forms/AccessListForm";

const OrganizationAccessListDownload = () => {
  const context = {};
  const [isValid, setIsValid] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matchEdit = useMatch("/:id/access/:accessListID/*");

  const accessNotifications = useSelector(selectAccessListNotifications);
  const currentList = useSelector(selectCurrentList);
  const uploadedFile = useSelector(selectUploadedFile);
  const validatedMember = useSelector(selectValidatedMember);

  context.setFile = (files) => {
    const file = files[0];
    if (file) {
      const data = createFormFromFile(file);
      dispatch(uploadFile(data));
    }
  };

  context.removeSourceItem = () => {
    dispatch(setValidatedMember({}))
    dispatch(setUploadedFile(""))
  }

  const backToList = () => {
    dispatch(clearNotifications());
    dispatch(clearUtilityNotifications());
    setSelectedFile({});
    dispatch(setValidatedMember({}))
    navigate(`/${matchEdit.params.id}/access/${matchEdit.params.accessListID}`);
  };

  const load = useCallback(() => {
    dispatch(getOrganizationAccessList(matchEdit?.params?.accessListID));
  }, [dispatch, matchEdit?.params]);

  useEffect(() => {
    load();
    return () => {
      dispatch(setSelectedList({}));
    };
  }, [load, dispatch]);

  useEffect(() => {
    if (uploadedFile && uploadedFile !== selectedFile) {
      setSelectedFile(uploadedFile);
    }
    return () => {
      dispatch(setUploadedFile(""));
    };
  }, [uploadedFile, dispatch, selectedFile]);

  useEffect(() => {
    if ((selectedFile ?? "") !== "" && currentList?.id) {
      const verify = { filename: selectedFile, id: currentList?.id };
      dispatch(validateOrganizationAccessList(verify));
    }
  }, [selectedFile, currentList, dispatch]);

  useEffect(() => {
    if(validatedMember?.identifier)
    {
      setIsValid(true)
    }
  },[validatedMember])

  useEffect(() => {
    if (
      accessNotifications.length > 0 &&
      accessNotifications?.[0]?.state === "success" &&
      accessNotifications?.[0]?.header?.props?.value === "Access list has been imported"
    ) {
      navigate(`/${matchEdit.params.id}/access/${matchEdit.params.accessListID}`);
    }
  }, [accessNotifications, dispatch, navigate, matchEdit.params]);

  const uploadCodes = () => {
    setIsValid(false);
    dispatch(clearNotifications())
    if ((selectedFile ?? "") !== "" && currentList?.id) {
      const accessFile = { filename: selectedFile, id: currentList?.id };
      dispatch(importOrganizationAccessList(accessFile));
    }
  };

  const leftNavigation = () => {
    backToList();
  };

  const getActions = () => {
    let actions = [
      {
        name: "Upload Codes",
        action: uploadCodes,
        isDisabled: !isValid,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Upload Codes",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = accessNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: n.header.props.value.includes?.("validated") ? getUploadBannerActions()  : getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to Access List",
        size: "secondary",
        actionClick: backToList,
      },
    ];
  };

  const getUploadBannerActions = () => {
    return [
      {
        id: 1,
        title: "Upload Access List",
        size: "secondary",
        actionClick: uploadCodes,
      },
    ];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Upload Codes"
        formSections={accessListUploadForm(context, validatedMember)}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <organization-access-list-upload>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </organization-access-list-upload>
  );
};

export default OrganizationAccessListDownload;
